/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsUnityOptionsDistributionForceCompressionOption, FxIdDomainSettingsUnityOptionsDistributionForceCompressionOptionFromJSONTyped, FxIdDomainSettingsUnityOptionsDistributionForceCompressionOptionToJSON, } from './FxIdDomainSettingsUnityOptionsDistributionForceCompressionOption';
export function FxIdDomainSettingsUnityOptionsDistributionOptionsForceCompressionOptionFromJSON(json) {
    return FxIdDomainSettingsUnityOptionsDistributionOptionsForceCompressionOptionFromJSONTyped(json, false);
}
export function FxIdDomainSettingsUnityOptionsDistributionOptionsForceCompressionOptionFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsUnityOptionsDistributionForceCompressionOption(json)) {
        return FxIdDomainSettingsUnityOptionsDistributionForceCompressionOptionFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsUnityOptionsDistributionOptionsForceCompressionOptionToJSON(json) {
    return FxIdDomainSettingsUnityOptionsDistributionOptionsForceCompressionOptionToJSONTyped(json, false);
}
export function FxIdDomainSettingsUnityOptionsDistributionOptionsForceCompressionOptionToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsUnityOptionsDistributionForceCompressionOption(value)) {
        return FxIdDomainSettingsUnityOptionsDistributionForceCompressionOptionToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsUnityOptionsDistributionOptionsForceCompressionOption.js.map